
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  modalController,
} from "@ionic/vue";
import videoModal from "./videoModal.vue";
import footerContactanos from "./footerContactanos.vue";
import headertoolbarstudio from "./header_toolbar_studio.vue";
import { Capacitor } from "@capacitor/core";

export default {
  name: "holdTelefonico",
  components: {
    IonHeader,
    IonToolbar,
    IonContent,
    IonPage,
    footerContactanos,
    headertoolbarstudio,
  },
  data() {
    return {
      platform: "",
    };
  },
  methods: {
    async openModal() {
      (document.activeElement as HTMLElement | null)?.blur();
      const modal = await modalController.create({
        component: videoModal,
        componentProps: {
          title: "Hold Telefónico",
          video: "assets/videos/HoldTelefonico.m4v",
        },
      });
      return modal.present();
    },
  },
  mounted() {
    this.platform = Capacitor.getPlatform();
  },
};
